import { IColumn } from "../types/User/IGridState";
import { IUserProfile } from "../types/User/User";

export const defaultColumns = (profile: IUserProfile): IColumn[] => [{
    field: 'Id',
    title: `${profile.Phrases.CallPhrase} #`,
    hidden: false,
    width: 100,
    groupable: true,
    groupField: 'State',
    groupTitle: 'State'
},
{
    field: 'Open_Dt',
    title: 'Created',
    hidden: false,
    width: 100,
    groupable: false,
    groupField: 'Open_Dt_Group'
},
{
    field: 'Due_Dt',
    title: 'Due',
    hidden: false,
    width: 100,
    groupable: false,
    groupField: 'Due_Dt_Group'
},
{
    field: 'Call_Desc',
    title: 'Description',
    hidden: false
},
{
    field: 'Status_Name',
    title: 'Status',
    hidden: false,
    width: 150,
    groupable: true,
    groupField: 'Status_Name'
},
{
    field: 'Company_Name',
    title: `${profile.Phrases.Client}`,
    hidden: false,
    width: 150,
    groupable: true,
    groupField: 'Company_Name'
},
{
    field: 'Project_Name',
    title: `${profile.Phrases.Project}`,
    hidden: false,
    width: 150,
    groupable: true,
    groupField: 'Project_Name'
},
{
    field: 'Address_Name',
    title: `${profile.Phrases.Office}`,
    hidden: true,
    width: 150,
    groupable: true,
    groupField: 'Address_Name'
},
{
    field: 'End_User_Name',
    title: `${profile.Phrases.EndUser}`,
    hidden: true,
    width: 150,
    groupable: true,
    groupField: 'End_User_Name'
},
{
    field: 'Company_Type_Name',
    title: `${profile.Phrases.Client} Type`,
    hidden: true,
    width: 150,
    groupable: true,
    groupField: 'Company_Type_Name'
},
{
    field: 'SLA_Name',
    title: `${profile.Phrases.SLA}`,
    hidden: true,
    width: 150,
    groupable: true,
    groupField: 'SLA_Name'
},
{
    field: 'Priority_Name',
    title: `${profile.Phrases.Priority}`,
    hidden: false,
    width: 150,
    groupable: true,
    groupField: 'Priority_Name'
},
{
    field: 'Type',
    title: `${profile.Phrases.Type}`,
    hidden: true,
    width: 150,
    groupable: true,
    groupField: 'Type'
},
{
    field: 'Sub_Type',
    title: `${profile.Phrases.SubType2}`,
    hidden: true,
    width: 150,
    groupable: true,
    groupField: 'Sub_Type'
},
{
    field: 'Assigned_Staff',
    title: 'Assigned To',
    hidden: false,
    width: 150,
    groupable: true,
    groupField: 'Assigned_Group'
}
] as IColumn[]